import { initialize } from 'launchdarkly-js-client-sdk';

// Single anonymous LaunchDarkly client shared across the page. It is memoized on
// window so every bundle loaded together (application, verify, online) reuses one
// client instead of each calling initialize() with the same anonymous context.
const CACHE_KEY = '__fituneAnonymousLdClient';

export function getAnonymousLdClient() {
  if (typeof window === 'undefined') return null;
  if (!window[CACHE_KEY]) {
    window[CACHE_KEY] = initialize(process.env.VUE_APP_LAUNCHDARKLY_CLIENTSIDE_ID, {
      kind: 'user',
      key: 'anonymous',
      anonymous: true
    });
  }
  return window[CACHE_KEY];
}
